export function NotFound(): JSX.Element {
  return <div className="page text-sm text-muted-foreground">Page not found.</div>;
}
